import type { ChipColorUnion } from '@vk-hr-tek/ui/ColoredChip';
import type { TypographyColor } from '@vk-hr-tek/ui/Typography';

import type {
  ChildCompaniesPoliciesItem,
  CompanyPolicyListItem,
} from '@app/gen/policy';

export const SIGNATURE_TYPE_OPTIONS = [
  {
    value: 'pep',
    label: 'ПЭП',
  },
  {
    value: 'unep',
    label: 'УНЭП/УКЭП',
  },
];

const UNEP_UKEP_HINT =
  'УНЭП (Усиленная неквалифицированная электронная подпись) или УКЭП (Усиленная квалифицированная электронная подпись)';

export const SIGNATURE_TYPE_HINTS = {
  pep: 'ПЭП (Простая электронная подпись)',
  unep: UNEP_UKEP_HINT,
  ukep: UNEP_UKEP_HINT,
  unep_disabled: '',
} as const;

export const DOCUMENT_TYPE_TEXT = {
  parent: 'Родительский',
  child: 'Дочерний',
};

export const VERSION_STATUS_CHIP = {
  draft: {
    label: 'Черновик',
    chipColor: 'gray',
    textColor: 'text.light.primary',
  },
  past: {
    label: 'Прошлая',
    chipColor: 'gray',
    textColor: 'text.light.primary',
  },
  actual: {
    label: 'Актуальная версия',
    chipColor: 'green',
    textColor: 'accent.text.success',
  },
  future: {
    label: 'Будущая',
    chipColor: 'blue',
    textColor: 'accent.text.blue',
  },
} as const satisfies Record<
  ChildCompaniesPoliciesItem['version_status'],
  { label: string; chipColor: ChipColorUnion; textColor: TypographyColor }
>;

export const VERSION_STATUS_TEXT = {
  draft: 'Черновик',
  past: 'Прошлая',
  actual: 'Актуальная',
  future: 'Будущая',
} as const satisfies Record<CompanyPolicyListItem['version_status'], string>;

export const DRAFT_VERSION_STATUS = 'draft';

export const ALL_VERSIONS_STATUS = 'all';

export const COMPANY_LIST_EMPTY_TEXT = {
  [ALL_VERSIONS_STATUS]: 'Здесь будут корпоративные документы',
  [DRAFT_VERSION_STATUS]: 'Здесь будут черновики документов',
};

export const WITH_ORDER_OPTIONS = [
  {
    value: 'true',
    label: 'Да',
  },
  {
    value: 'false',
    label: 'Нет',
  },
];

export const KONTUR_UNAVAILABLE_LINKS = [
  {
    href: window.REACT_APP_VKHRTEK_STATUS_PAGE_LINK,
    name: 'Статус восстановления сервиса',
  },
  {
    href: window.REACT_APP_VKHRTEK_ABOUT_GOSKEY_LINK,
    name: 'Подробнее об УНЭП Госключ',
  },
];

export const MAX_LEVEL_WITH_CHILDREN = 0;

export const LEVEL_OFFSET_WITH_ICON = ['0', '24', '48'] as const;
export const LEVEL_OFFSET_WITHOUT_ICON = ['24', '48', '72'] as const;

export const MAX_NAME_LENGTH = 256;

export const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
};

export const CHILD_COMPANIES_LIMIT = 12;
export const MIN_CHILD_COMPANIES_COUNT = 2;

export const POSITIONS_LIMIT = 8;
export const EMPLOYEES_LIMIT = 8;

export const MAX_ATTACHED_FILES_COUNT = 10;

export const ATTACHED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/xml',
  'text/xml',
  'application/pkcs7-mime',
];

export const EMPLOYEES_ADDING_MODE_OPTIONS = [
  { label: 'Вручную', value: 'manual' },
  { label: 'Загрузить список', value: 'upload' },
];
